var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"ul-container"},[_c('li',[(_vm.content.contentType === 'position')?_c('positionLi',{attrs:{"content":_vm.content.content}}):_c('contentIndex',{attrs:{"bookContent":_vm.content.content}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }